module.exports = __webpack_public_path__ + "img/radar-shadow.8bd3add0.png";